class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/analyze-interaction`;
    }
    /**
     * Returns multiple insights including summaries, emotion, key phrases, questions asked, and more in a single API call.
     *
     * HTTP Method: post
     * Endpoint: /ai/insights/v1/async/analyze-interaction
     * Rate Limit Group: Heavy
     * App Permission: AI
     */
    async post(interactionInput, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), interactionInput, queryParams, restRequestConfig);
        return r.data;
    }
}
export default Index;
